export default __webpack_public_path__ + "static/media/17 CRANE.453bbd9e.png";